"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckIsOpenAcctRequest = void 0;
var CheckIsOpenAcctRequest = /** @class */ (function () {
    function CheckIsOpenAcctRequest() {
    }
    return CheckIsOpenAcctRequest;
}());
exports.CheckIsOpenAcctRequest = CheckIsOpenAcctRequest;
;
//# sourceMappingURL=checkIsOpenAcct.request.js.map